import links from "./links"

export default links
